// extracted by mini-css-extract-plugin
export default {"wrapper":"lclgi","label":"pEk98","error-message":"wyK4a","errorMessage":"wyK4a","root":"rWlxR","error":"shRrs"};